import { render, staticRenderFns } from "./CopilotModal.vue?vue&type=template&id=4d3bce2e"
import script from "./CopilotModal.vue?vue&type=script&lang=js"
export * from "./CopilotModal.vue?vue&type=script&lang=js"
import style0 from "./CopilotModal.vue?vue&type=style&index=0&id=4d3bce2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports